import { createAction } from '@reduxjs/toolkit';

export const calendarNavigationKey = 'calendarNavigation';

export interface CalendarNavigationState {
    readonly rulerDateRange: [string, string];
}

export enum CalendarNavigationActionTypes {
    rulerDateRange = 'calendarNavigation/rulerDateRangeSet',
}
export const rulerDateRangeSet = createAction<[string, string]>(CalendarNavigationActionTypes.rulerDateRange);

export type CalendarNavigationActions = ReturnType<typeof rulerDateRangeSet>;
